<template>
  <div class="home-component">
    <Slider />
    <br />
    <div class="container">
      <nav aria-label="breadcrumb"></nav>
    </div>
    <template v-if="banner_data != null">
      <BestProductsModule :banner="banner_data" />
    </template>
    <GoToTrackingModule />
    <NewsModule />
    <MultimediaModule />
    <GuideModule />
  </div>
</template>
<script>
import { config_settings } from '@/config.js';
import MultimediaModule from '@/modules/MultimediaModule.vue';
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import NewsModule from '@/modules/NewsModule.vue';
import GuideModule from '@/modules/GuideModule.vue';
import Slider from '@/components/slider/Slider.vue';
import BestProductsModule from '@/modules/BestProductsModule.vue';
import { configData } from '@/helpers/localStorage.helpers';

export default {
  name: 'home',
  components: {
    Slider,
    BestProductsModule,
    GoToTrackingModule,
    MultimediaModule,
    NewsModule,
    GuideModule,
  },
  props: ['subSectionData', 'configData'],
  data() {
    return {
      url_1st_image: 'products/empty-img',
      url_2nd_image: 'products/empty-img',
      url_3rd_image: 'products/empty-img',
      type_1st_image: 'image',
      type_2nd_image: 'image',
      type_3rd_image: 'image',
      banner_data: {
        first: { photo: 'products/empty-img', url: '' },
        second: { photo: 'products/empty-img', url: '' },
        third: { photo: 'products/empty-img', url: '' },
      },
    };
  },
  mounted() {
    if (this.configData.startProps.isMarketingModalAvailable) {
      $('#MarketingModal').modal('show');
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    normalizeSubSectionData() {
      this.url_1st_image = this.subSectionData.url_1st_image;
      this.url_2nd_image = this.subSectionData.url_2nd_image;
      this.url_3rd_image = this.subSectionData.url_3rd_image;
      this.type_1st_image = this.subSectionData.type_1st_image;
      this.type_2nd_image = this.subSectionData.type_2nd_image;
      this.type_3rd_image = this.subSectionData.type_3rd_image;
      this.banner_data = {
        first: { photo: this.url_1st_image, url: this.type_1st_image },
        second: { photo: this.url_2nd_image, url: this.type_2nd_image },
        third: { photo: this.url_3rd_image, url: this.type_3rd_image },
      };
    },
  },
  created() {
    this.scrollToTop();
    this.normalizeSubSectionData();
  },
};
</script>
